import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function Support() {
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Brukerstøtte</h1>
        
        <div className="space-y-6 text-gray-600">
          <p>
            Har du synspunkter om eller spørsmål til bruken av appen, ta kontakt med oss.
          </p>
          
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
            <h2 className="text-xl font-semibold text-blue-900 mb-4">Kontakt oss</h2>
            <div className="flex items-center text-blue-700">
              <Mail className="h-5 w-5 mr-2" />
              <a href="mailto:post@transport.no" className="hover:text-blue-900">
                post@transport.no
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8">
          <Link
            to="/login"
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Tilbake til innlogging
          </Link>
        </div>
      </div>
    </div>
  );
}